import { userSchema } from 'src/common-services/types/user-types'
import { z } from 'zod'

export const amJWTPayloadShema = z.object({
  id: userSchema.shape.id,
  email: userSchema.shape.email,
  type: z.literal('identity'),
})

export type AMJWTPayload = z.infer<typeof amJWTPayloadShema>

export const amAuthTilesShema = z.object({
  host: z.string(),
  token: z.string(),
  verify: z.string(),
})

export type AMAuthTiles = z.infer<typeof amAuthTilesShema>

export const amPOIDensitySchema = z.union([z.literal('low'), z.literal('medium'), z.literal('high')])

export type AMPOIDensity = z.infer<typeof amPOIDensitySchema>

export const amPOICategorySchema = z.union([
  z.literal('Retail'),
  z.literal('Medical'),
  z.literal('Office'),
  z.literal('Industrial'),
  z.literal('Hospitality'),
  z.literal('Other'),
  z.literal('Shopping Center'),
])
export type AMPOICategory = z.infer<typeof amPOICategorySchema>
